import { Description, Field, Label } from "@headlessui/react";
import { useState } from "react";
import DropdownMenu from "./DropdownMenu";
import clsx from "clsx";

const defaultOptions = [
  { value: "active", label: "Active" },
  { value: "paused", label: "Paused" },
  { value: "delayed", label: "Delayed" },
  { value: "canceled", label: "Canceled" },
];

const Select = ({
  label,
  description,
  options = defaultOptions,
  onChange = () => {},
  defaultValue = null,
  width = "w-full",
  name,
  className,
}) => {
  const [selectedValue, setSelectedValue] = useState(
    defaultValue || options[0]?.value
  );
  const selectedOption =
    options.find((option) => option.value === selectedValue) || options[0];

  const handleChange = (value) => {
    setSelectedValue(value);

    // Create a synthetic event object that has expected properties
    onChange({
      target: {
        name: name,
        value: value,
      },
    });
  };

  // Transform options for DropdownMenu
  const dropdownItems = options.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  return (
    <div className={width}>
      <Field className="w-full">
        {label && (
          <Label className="text-sm/6 font-medium text-gray-700">{label}</Label>
        )}
        {description && (
          <Description className="text-sm/6 text-gray-500">
            {description}
          </Description>
        )}
        <div className="relative w-full">
          <DropdownMenu
            buttonText={selectedOption?.label || "Select..."}
            items={dropdownItems}
            onChange={handleChange}
            selectedValue={selectedValue}
            className={clsx("w-full", className)}
            buttonClassName="inline-flex w-full justify-between items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm/6 text-gray-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 focus:outline-none"
            menuItemsClassName="w-full origin-top rounded-lg bg-white p-1 text-sm/6 text-gray-700 shadow-lg ring-1 ring-black ring-opacity-5 transition duration-100 ease-out focus:outline-none data-closed:scale-95 data-closed:opacity-0"
          />
        </div>
      </Field>
    </div>
  );
};

export default Select;
